<template>
  <div class="no-results">
    <p>No hay prestadores de salud que coincidan con tu búsqueda.</p>
  </div>
</template>

<script>
export default {
  name: 'NoResults'
}
</script>
